import { UserConstants } from '../constants';

let initialState = { certificatesBD: [], certificatesBDCreating: false, certificatesBDCreated: false, certificatesBDError: '' };
export function certificatesBD(state = initialState, action) {
    switch (action.type) {
    case UserConstants.CERTIFICATESBD_SUCCESS:
        return {
            certificatesBD: action.payload.data,
            certificatesBDCreated: true,
            certificatesBDCreating: false,
            certificatesBDError: '',
        };
    case UserConstants.CERTIFICATESBD_REQUEST:
        return {
            certificatesBD: [],
            certificatesBDCreating: true,
            certificatesBDCreated: false,
            certificatesBDError: '',
        };
    case UserConstants.CERTIFICATESBD_ERROR:
        return {
            certificatesBD: [],
            certificatesBDCreated: false,
            certificatesBDCreating: false,
            certificatesBDError: action.payload.message
        };
    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/CertificatesByD.jsx